import { render, staticRenderFns } from "./Store-wrapper.vue?vue&type=template&id=2156884c&"
import script from "./Store-wrapper.vue?vue&type=script&lang=js&"
export * from "./Store-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./Store-wrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports